export default {
  slug: "dottrace",
  code: "DT",
  label: "dotTrace",
  krakenDir: "dotTrace",
  thumbnailColor: "#FF45ED",
  logoFamily: "jb",
};
